<template>
    <div>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        highlight-row
        stripe
        max-height="700"
      >
      </Table>
    </div>
  </template>
  <script>
  export default {
    name: 'tableExpand',
    props: {
      row: Object
    },
    data() {
      return {}
    },
    computed: {
      resources() {
        return this.row.kot_printers
      },
      columns() {
        return [
          {
            title: this.$t('productGroup.printer'),
            key: 'printer_name',
            width: 385
          },
          {
            title: this.$t('productGroup.ipAddress'),
            key: 'printer_ip_adress',
            width: 383
          },
          {
            title: this.$t('productGroup.port'),
            key: 'port',
            width: 383
          },
          {
            title: this.$t('productGroup.type'),
            key: 'input_type',
            width: 383
          },
        ]
      }
    },
    methods: {}
  }
  </script>
  